import styled from "styled-components";

type SummaryBoxProps = {
  title: string;
  items: Array<{ label: string; value: string | number; tone?: "default" | "warning" | "success" }>;
};

export function SummaryBox({ title, items }: SummaryBoxProps) {
  return (
    <Wrapper>
      <Header>{title}</Header>
      <List>
        {items.map((item, i) => (
          <Item key={i}>
            <Bullet $tone={item.tone ?? "default"}>•</Bullet>
            <Label>{item.label}</Label>
            <Value $tone={item.tone ?? "default"}>{item.value}</Value>
          </Item>
        ))}
      </List>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  background: ${({ theme }) => theme.color.surface};
  border: 1px solid ${({ theme }) => theme.color.border};
  border-radius: ${({ theme }) => theme.radius.md};
  padding: ${({ theme }) => theme.space.lg};
`;

const Header = styled.div`
  font-size: ${({ theme }) => theme.font.size.sm};
  font-weight: ${({ theme }) => theme.font.weight.medium};
  color: ${({ theme }) => theme.color.textMuted};
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: ${({ theme }) => theme.space.md};
`;

const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.space.xs};
`;

const Item = styled.li`
  display: flex;
  align-items: baseline;
  gap: ${({ theme }) => theme.space.sm};
  font-size: ${({ theme }) => theme.font.size.sm};
`;

const Bullet = styled.span<{ $tone: "default" | "warning" | "success" }>`
  color: ${({ theme, $tone }) =>
    $tone === "warning"
      ? theme.color.warning
      : $tone === "success"
        ? theme.color.success
        : theme.color.textDim};
`;

const Label = styled.span`
  color: ${({ theme }) => theme.color.textPrimary};
  flex: 1;
`;

const Value = styled.span<{ $tone: "default" | "warning" | "success" }>`
  font-family: ${({ theme }) => theme.font.mono};
  font-weight: ${({ theme }) => theme.font.weight.medium};
  color: ${({ theme, $tone }) =>
    $tone === "warning"
      ? theme.color.warning
      : $tone === "success"
        ? theme.color.success
        : theme.color.textPrimary};
`;
